import { render } from "./Nomination.vue?vue&type=template&id=1d025a9b&scoped=true"
import script from "./Nomination.vue?vue&type=script&lang=js"
export * from "./Nomination.vue?vue&type=script&lang=js"

import "./Nomination.vue?vue&type=style&index=0&id=1d025a9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d025a9b"]])

export default __exports__